import React, { Fragment } from "react";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 250,
  },
}));
function CheckboxQuestion(props) {
  const classes = useStyles();

  function handleChange(e) {
    if (props.onChange) {
      props.onChange(e.target.value);
    }
  }

  return (
    <Fragment>
      <Box pt={4}>
          
        <FormControl className={classes.formControl}>
        <Typography  variant="h6" gutterBottom>
           {props.question}
          </Typography>
          {/* <InputLabel id="select-label">{props.question}</InputLabel> */}
          <Select
            labelId="select-label"
            value={props.selected}
            onChange={handleChange}
          >
            {props.options.map((option, i) => (
              <MenuItem key={i} value={option.label}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Fragment>
  );
}

export default CheckboxQuestion;
